<div class="square-setup">
  <!-- Header -->

  <div class="setup-header">
    <button type="button" class="back-button" (click)="close()">
      ← Back to integrations
    </button>

    <div class="setup-header__main">
      <div>
        <span class="setup-kicker"> Square </span>

        <h2>Configure Square</h2>

        <p>
          Match your existing Square setup with gloget before enabling booking
          synchronization.
        </p>
      </div>
    </div>
  </div>

  <!-- Error -->

  <div *ngIf="errorMessage" class="setup-notice setup-notice--error">
    {{ errorMessage }}
  </div>

  <!-- Success -->

  <div *ngIf="successMessage" class="setup-notice setup-notice--success">
    {{ successMessage }}
  </div>

  <!-- Loading -->

  <div *ngIf="loading" class="setup-loading">
    <span class="setup-spinner"></span>

    <div>
      <strong> Loading Square configuration </strong>

      <p>Retrieving locations, services and staff.</p>
    </div>
  </div>

  <ng-container *ngIf="!loading && setup">
    <!-- Navigation -->

    <div class="setup-nav">
      <button
        type="button"
        class="setup-nav__item"
        [class.setup-nav__item--active]="activeSection === 'locations'"
        (click)="selectSection('locations')"
      >
        <span class="setup-nav__number"> 1 </span>

        <span class="setup-nav__content">
          <strong> Locations </strong>

          <small>
            {{ locationsMapped }}
            /
            {{ locationsTotal }}
            mapped
          </small>
        </span>
      </button>

      <button
        type="button"
        class="setup-nav__item"
        [class.setup-nav__item--active]="activeSection === 'services'"
        (click)="selectSection('services')"
      >
        <span class="setup-nav__number"> 2 </span>

        <span class="setup-nav__content">
          <strong> Services </strong>

          <small>
            {{ servicesMapped }}
            /
            {{ servicesTotal }}
            mapped
          </small>
        </span>
      </button>

      <button
        type="button"
        class="setup-nav__item"
        [class.setup-nav__item--active]="activeSection === 'staff'"
        (click)="selectSection('staff')"
      >
        <span class="setup-nav__number"> 3 </span>

        <span class="setup-nav__content">
          <strong> Staff </strong>

          <small>
            {{ staffMapped }}
            /
            {{ staffTotal }}
            mapped
          </small>
        </span>
      </button>

      <button
        type="button"
        class="setup-nav__item"
        [class.setup-nav__item--active]="activeSection === 'review'"
        (click)="selectSection('review')"
      >
        <span class="setup-nav__number"> 4 </span>

        <span class="setup-nav__content">
          <strong> Review </strong>

          <small> Booking sync </small>
        </span>
      </button>
    </div>

    <!-- ==================================================
         Locations
    =================================================== -->

    <app-square-locations
      *ngIf="activeSection === 'locations'"
      [setup]="setup"
      (mappingChanged)="handleMappingChanged()"
    ></app-square-locations>

    <!-- ==================================================
         Services placeholder
    =================================================== -->

    <app-square-services
      *ngIf="activeSection === 'services'"
      [setup]="setup"
      (mappingChanged)="handleMappingChanged()"
    ></app-square-services>

    <!-- ==================================================
         Staff placeholder
    =================================================== -->

    <app-square-staff
      *ngIf="activeSection === 'staff'"
      [setup]="setup"
      (mappingChanged)="handleMappingChanged()"
    ></app-square-staff>

    <!-- ==================================================
         Review placeholder
    =================================================== -->

    <div *ngIf="activeSection === 'review'" class="coming-step">
      <span> Final step </span>

      <h3>Booking synchronization</h3>

      <p>
        Once locations, services and staff are mapped, you will be able to
        enable automatic two-way booking synchronization.
      </p>
    </div>
  </ng-container>
</div>
